// Writes activity logs with business and facility scope fields in one place.
import { supabase } from '@/integrations/supabase/client';
import type { Enums, Json } from '@/integrations/supabase/types';

type ActivityAction =
  | Enums<'activity_action'>
  | 'facility_created'
  | 'facility_updated'
  | 'facility_deleted'
  | 'favorite_facility_added'
  | 'favorite_facility_removed';

interface LogUserActivityParams {
  userId: string;
  action: ActivityAction;
  entityType?: string | null;
  entityId?: string | null;
  details?: Json | null;
  businessId?: string | null;
  facilityId?: string | null;
}

export const logUserActivity = async ({
  userId,
  action,
  entityType = null,
  entityId = null,
  details = null,
  businessId = null,
  facilityId = null,
}: LogUserActivityParams) => {
  return supabase.from('activity_logs').insert({
    user_id: userId,
    action,
    entity_type: entityType,
    entity_id: entityId,
    details,
    business_id: businessId,
    facility_id: facilityId,
    user_agent: navigator.userAgent,
  });
};
